import { IProductAddOptions } from "@faire/deprecated-retailer-visitor-shared/features/ProductAdd/ProductAddOptions";
import { useCartItems } from "@faire/deprecated-retailer-visitor-shared/hooks/cart/useCartItems";
import { useCartUpdate } from "@faire/deprecated-retailer-visitor-shared/hooks/cart/useCartUpdate";
import { UpdateCartArg } from "@faire/deprecated-retailer-visitor-shared/stores/domain/CartStore/consts";

/**
 * Satisfies the IProductAddOptions interface by combining
 * useCartItems and useCartUpdate.
 */
export const useCartProductAddOptions = (): IProductAddOptions => {
  const {
    cartItems,
    getItemByToken,
    getProductTileQuantityInCart,
    getItemByProductOptionTokenAndCustomizations,
  } = useCartItems();
  const { updateCartItems } = useCartUpdate();

  return {
    addedItems: cartItems,
    getAddedItemByToken: getItemByToken,
    getAddedItemQuantityByToken: getProductTileQuantityInCart,
    getAddedItemByProductOptionTokenAndCustomizations:
      getItemByProductOptionTokenAndCustomizations,
    addOrUpdateItems: () => {},
    addOrUpdateItemsV2: (args: UpdateCartArg) => updateCartItems(args),
  };
};
